import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectedFspIdSelector } from 'selectors/fsp';
import { selector as fspConfigPayALoanSelector } from 'selectors/fspConfigPayALoan';
import useFlags from '../components/modules/implementation/Fsp/Detail/common/hooks/useFeatureFlags';

export default function useGuestPayerEnabled() {
  const { data, loading: flagLoading } = useFlags('ontrac-guest-payer');
  const fspId = useSelector(selectedFspIdSelector);
  const fspConfig = useSelector((state) =>
    fspConfigPayALoanSelector(state, fspId)
  );
  return useMemo(() => {
    const flagEnabled =
      !flagLoading &&
      data !== null &&
      data.FlagValue !== null &&
      data.FlagValue;
    const configEnabled = fspConfig?.ifpPalOnOff === 'on';
    return flagEnabled && configEnabled;
  }, [flagLoading, data, fspConfig]);
}
